/**
 * Utility functions for string operations
 */

/**
 * Escapes special characters in filter values for OData queries
 * @param value The value to escape
 * @returns The escaped value
 */
export const escapeFilterValue = (value: any): any => {
  if (typeof value === 'string') {
    // Replace single quotes with double single quotes (SQL standard escaping)
    let escapedValue = value.replace(/'/g, "''");
    
    // URL encode ampersands and hashtags
    escapedValue = escapedValue.replace(/&/g, "%26");
    escapedValue = escapedValue.replace(/#/g, "%23");
    
    return escapedValue;
  }
  return value;
};